import { makeService } from './api';

const service = makeService('addresses');

export default service;